var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var {
  View,
} = ReactNative;

export default createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    return <svg {...this.props} />
  }
});

var G = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      scale:1
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    return <g transform={"scale("+this.props.scale+")"}>{this.props.children}</g>;
  }
});

var Path = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      d:"",
      stroke:'black',
      strokeWidth:2,
      strokeLinecap:'round',
      fill:'none'
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    return <path {...this.props} />
  }
});

export {Path as Path,
G as G ,
View as Circle}



// WEBPACK FOOTER //
// ./src/wrappers/react-native-svg-wrapper.js